import { create } from "zustand";

interface GlobalState {
  latestSelectId: string;
  isSrcDocExpand: boolean;
  isSummaryExpand: boolean;
}
interface GlobalStore extends GlobalState {
  setLatestSelectId: (latestSelectId: string) => void;
  setIsSrcDocExpand: (isSrcDocExpand: boolean) => void;
  setIsSummaryExpand: (isSummaryExpand: boolean) => void;
}

const globalState: GlobalState = {
  latestSelectId: "",
  isSrcDocExpand: false,
  isSummaryExpand: false,
};

const globalStore = create<GlobalStore>()((set) => ({
  ...globalState,
  setLatestSelectId: (latestSelectId: string) => {
    set({ latestSelectId });
  },
  setIsSrcDocExpand: (isSrcDocExpand: boolean) => {
    set({ isSrcDocExpand });
  },
  setIsSummaryExpand: (isSummaryExpand: boolean) => {
    set({ isSummaryExpand });
  },
}));

export default globalStore;
